import { defineView } from "eddev/views"
import { PageProvider } from "../contexts/PageContext"
import { SiteFooter } from "@components/site/SiteFooter"
import { FilmTile } from "@components/film/FilmTile"
import { useMemo } from "react"
import { CenteredBlocks } from "@components/site/CenteredBlocks"

export default defineView("single-program", (props) => {
  const films = useMemo(() => {
    return props.program?.films?.sort((a, b) => a?.title!.localeCompare(b?.title!)!)
  }, [props.program?.films])

  return (
    <PageProvider theme={"yellow"}>
      <CenteredBlocks contentBlocks={props.program?.contentBlocks} />
      <div className="grid-auto mt-8">
        <div className="col-span-12">
          <h3 className="type-title-s mb-4">Films</h3>
        </div>
        <div className="col-span-12">
          <div className="grid-auto gap-y-4">
            {films?.map((film) => {
              return (
                <div key={film?.id} className="col-span-6 md:col-span-4 lg:col-span-3">
                  <FilmTile film={film!} />
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <SiteFooter />
    </PageProvider>
  )
})
